import { CONTACT_INDIVIDUAL_SUBTYPES_WITH_ADDITIONAL_FIELDS } from "@/lib/data/static/contactStatics";
import { type Contact } from "@/lib/types";
import dayjs from "dayjs";
import pluralize from "pluralize";

interface ContactIndividualDetailsProps {
  contact: Contact;
}

export const ContactIndividualDetails = ({
  contact,
}: ContactIndividualDetailsProps) => {
  const dateOfBirth = contact.individualDateOfBirth;
  const age =
    dateOfBirth != null && String(dateOfBirth) !== ""
      ? dayjs().diff(dayjs(dateOfBirth as string | number | Date), "year")
      : 0;
  return (
    <table className="table table-auto">
      <tbody>
        <tr className="table-row">
          <td>Nickname:</td>
          <td className="pl-2">{contact.individualNickname || "-"}</td>
        </tr>
        <tr className="table-row">
          <td>Title:</td>
          <td className="pl-2">{contact.title || "-"}</td>
        </tr>
        <tr className="table-row">
          <td>Middle name:</td>
          <td className="pl-2">{contact.individualMiddleName || "-"}</td>
        </tr>
        {(contact.individualSubTypes ?? []).some((subType) =>
          CONTACT_INDIVIDUAL_SUBTYPES_WITH_ADDITIONAL_FIELDS.includes(
            subType as (typeof CONTACT_INDIVIDUAL_SUBTYPES_WITH_ADDITIONAL_FIELDS)[number],
          ),
        ) && (
          <>
            <tr className="table-row">
              <td>Date of birth:</td>
              <td className="pl-2">
                {dateOfBirth
                  ? dayjs(dateOfBirth as string | number | Date).format(
                      "MMMM D, YYYY",
                    )
                  : "-"}
                {dateOfBirth && (
                  <span className="pl-2 text-gray-400">
                    {`(${pluralize("years", age, true)} old)`}
                  </span>
                )}
              </td>
            </tr>
            <tr className="table-row">
              <td>SSN:</td>
              <td className="pl-2">
                {contact.individualSocialSecurityNumber || "-"}
              </td>
            </tr>
            <tr className="table-row">
              <td>Driver license number:</td>
              <td className="pl-2">
                {contact.individualDriverLicenseNumber || "-"}
              </td>
            </tr>
            <tr className="table-row">
              <td>Driver license state:</td>
              <td className="pl-2">
                {contact.individualDriverLicenseState || "-"}
              </td>
            </tr>
            <tr className="table-row">
              <td>Gender:</td>
              <td className="pl-2">{contact.individualGender || "-"}</td>
            </tr>
            <tr className="table-row">
              <td>Primary language:</td>
              <td className="pl-2">
                {contact.individualPrimaryLanguage || "-"}
              </td>
            </tr>
            <tr className="table-row">
              <td>
                {pluralize(
                  "Secondary language",
                  contact.individualSecondaryLanguage?.length,
                )}
                :
              </td>
              <td className="pl-2">
                {contact.individualSecondaryLanguage &&
                contact.individualSecondaryLanguage.length > 0
                  ? contact.individualSecondaryLanguage.join(", ")
                  : "-"}
              </td>
            </tr>
            <tr className="table-row">
              <td>Race:</td>
              <td className="pl-2">
                {contact.individualRace && contact.individualRace.length > 0
                  ? contact.individualRace.join(", ")
                  : "-"}
              </td>
            </tr>
            <tr className="table-row">
              <td>Deceased:</td>
              <td className="pl-2">
                {contact.individualDeceased ? "Yes" : "No"}
              </td>
            </tr>
          </>
        )}
        {contact.individualSubTypes &&
          (contact.individualSubTypes as string[]).includes(
            "Expert Witness",
          ) && (
            <tr className="table-row">
              <td>Expert witness specializations:</td>
              <td className="pl-2">
                {contact.individualExpertWitnessSpecialization?.join(", ") ||
                  "-"}
              </td>
            </tr>
          )}
      </tbody>
    </table>
  );
};
